import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IDispositivoAlarma,
  IActivo,
  ICreateConfigEventoUsuario,
  IUpdateConfigEventoUsuario,
  IEstadoEntidad,
  estadoCuenta,
  ITracker,
} from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { EstadoEntidadsService } from '../estado-entidad.service';
import { InfoBannerComponent } from '../../../../../componentes/info-banner/info-banner.component';
import { CardHeaderComponent } from '../../../../../componentes/card-header/card-header.component';

@Component({
  imports: [AuxiliaresModule, InfoBannerComponent, CardHeaderComponent],
  selector: 'app-crear-editar-estado-cuenta',
  templateUrl: './crear-editar-estado-cuenta.component.html',
  styleUrl: './crear-editar-estado-cuenta.component.scss',
})
export class CrearEditarEstadoCuentaComponent implements OnInit {
  data = inject<{
    estadoEntidad?: IEstadoEntidad;
    activo?: IActivo;
    alarma?: IDispositivoAlarma;
    tracker?: ITracker;
  }>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<CrearEditarEstadoCuentaComponent>>(MatDialogRef);
  helper = inject(HelperService);
  private service = inject(EstadoEntidadsService);
  private dialogService = inject(DialogService);

  public form: FormGroup;
  public title?: string;
  public loading = false;
  public nombreEntidad?: string;

  public estados: estadoCuenta[] = ['Habilitado', 'Suspendido'];
  public motivos: string[] = [
    'Baja o suspensión de módulo',
    'Cambio de tituralidad',
    'Mail del gremio',
    'Sin Motivo',
    'Mudanza',
    'Solicitado por cliente',
    'Suspención por cobranzas',
  ];

  get isCuentaSuspendida(): boolean {
    // Solo muestra el banner de advertencia si el estado seleccionado es Suspendido
    // pero NO deshabilita el formulario porque es un historial
    return this.form?.get('estado')?.value === 'Suspendido';
  }

  get esVistaHistorial(): boolean {
    // Determina si estamos viendo un registro histórico (tiene estadoEntidad con _id)
    return !!this.data?.estadoEntidad?._id;
  }

  private createForm() {
    this.form = new FormGroup({
      // estado?: estadoCuenta;
      // idEntidad?: string; /// POR DISPOSITIVO
      // idCliente?: string; /// Back End
      // idUsuario?: string; /// Back End
      // nota?: string;
      // motivos?: string[];
      // vigencia?: string; // Desde cuando se aplica el estado
      estado: new FormControl(this.data.estadoEntidad?.estado, [
        Validators.required,
      ]),
      idEntidad: new FormControl(this.data.estadoEntidad?.idEntidad, [
        Validators.required,
      ]),
      nota: new FormControl(this.data.estadoEntidad?.nota),
      motivos: new FormControl(this.data.estadoEntidad?.motivos),
    });
  }

  //
  public async onSubmit() {
    this.loading = true;
    const res = await this.dialogService.confirm(
      `Confirmá la acción`,
      `¿Querés ${this.title.toLowerCase()} ?`,
    );
    if (!res) return;
    try {
      const data = this.getData();
      if (this.data?.estadoEntidad?._id) {
        // Update
        await this.service.update(this.data.estadoEntidad._id, data);
        this.helper.notifSuccess('Estado de cuenta actualizada');
        this.dialogRef.close(true);
      } else {
        // Create
        await this.service.create(data);
        this.helper.notifSuccess('Estado de cuenta creada');
        this.dialogRef.close(true);
        this.loading = false;
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
      this.loading = false;
    }
  }

  public getData(): ICreateConfigEventoUsuario | IUpdateConfigEventoUsuario {
    const data: ICreateConfigEventoUsuario | IUpdateConfigEventoUsuario =
      this.form?.value;
    return data;
  }

  private patchIdEntidad() {
    if (this.data?.activo) {
      this.form.patchValue({ idEntidad: this.data.activo.idTracker });
    } else if (this.data?.alarma) {
      this.form.patchValue({ idEntidad: this.data.alarma._id });
    } else if (this.data?.tracker) {
      this.form.patchValue({ idEntidad: this.data.tracker._id });
    }
  }

  async ngOnInit() {
    this.title =
      this.data.estadoEntidad ||
      this.data.activo ||
      this.data.alarma ||
      this.data.tracker
        ? 'Editar estado de la cuenta'
        : 'Cambiar estado de la cuenta';

    // Obtener nombre de la entidad
    this.nombreEntidad =
      this.data.activo?.identificacion ||
      this.data.alarma?.nombre ||
      this.data.tracker?.identificacion;

    this.createForm();
    this.patchIdEntidad();

    // NO deshabilitar controles - este es un formulario de historial que siempre debe ser editable
    // La lógica anterior estaba incorrecta porque impedía editar registros históricos
  }
}
